import { Box, Dialog, DialogContent, Grid, Slide } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from "../Contexts/GlobalContext";
import { UserContext } from "../Contexts/UserContext";
import successGif from "../assets/successGif.gif";
import { verifyLogin } from "../api/agent";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const OtpLogin = ({ open, handleClose }) => {
  let interval;
  const { otpState, resetState, showRewardState } = useContext(GlobalContext);
  const { setUser, signUpDataState } = useContext(UserContext);

  const [vId, setVid] = useState("");
  const [isOver, setOver] = useState(false);
  const navigate = useNavigate();

  const [otpData, setOtpData] = otpState;
  const [isResetVerified, setResetVerified] = resetState;
  const [isVerified, setVerified] = useState(false);

  let inputs = [];

  const [otp, setOtp] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [timer, setTimer] = useState("05:00");
  const { enqueueSnackbar } = useSnackbar();

  const input1 = useRef(null);
  const input2 = useRef(null);
  const input3 = useRef(null);
  const input4 = useRef(null);
  const timerRef = useRef(null);
  const verification = useRef(null);

  useEffect(() => {
    if (!open) {
      clearInterval(interval);
    } else {
      startTimer(5 * 60);
    }
  }, []);

  useEffect(() => {
    setVid(otpData.vId);
  }, [otpData]);

  const handleInput = (target) => {
    if (/^\d+$/.test(target.value)) {
      getOTP();
      let nextInput = target.nextElementSibling;

      if (nextInput && target.value) {
        nextInput.focus();
        nextInput.value && nextInput.select();
      }
    } else {
      target.value = "";
    }
  };

  const handleBackspace = (target) => {
    getOTP();
    return target.value
      ? (target.value = "")
      : target.previousElementSibling?.focus();
  };

  const handleArrowLeft = (target) => {
    const previousInput = target.previousElementSibling;
    return !previousInput ? undefined : previousInput.focus();
  };
  const handleArrowRight = (target) => {
    const nextInput = target.nextElementSibling;
    return !nextInput ? undefined : nextInput.focus();
  };

  const handlePaste = (event) => {
    let pasteText = (event.clipboardData || window.clipboardData).getData(
      "text"
    );

    const inputs = [
      input1.current,
      input2.current,
      input3.current,
      input4.current,
    ];

    inputs.forEach((input, index) => {
      input.value = pasteText[index] || ``;
      if (pasteText[index]) {
        input?.focus();
      }
    });
    getOTP();
    event.preventDefault();
  };

  useEffect(() => {
    autoFetch();
  }, []);

  const autoFetch = async () => {
    const signal = new AbortController();
    setTimeout(() => {
      signal.abort();
    }, 1 * 60 * 1000);

    if ("OTPCredential" in window) {
      try {
        if (navigator.credentials) {
          try {
            await navigator.credentials
              .get({ abort: signal, otp: { transport: ["sms"] } })
              .then((content) => {
                if (content && content.code) {
                  input1.current.value = content.code[0];
                  input2.current.value = content.code[1];
                  input3.current.value = content.code[2];
                  input4.current.value = content.code[3];

                  setOtp(content.code);
                }
              })
              .catch((e) => console.log(e));
          } catch (e) {
            return;
          }
        }
      } catch (err) {
        console.log(err);
      }
    }

    // if ("OTPCredential" in window) {
    //   const ac = new AbortController();

    //   navigator.credentials
    //     .get({
    //       otp: { transport: ["sms"] },
    //       signal: ac.signal,
    //     })
    //     .then((otp) => {
    //       alert(otp);

    //       if (otp.length === 4) {
    //         input1.current.value = otp[0];
    //         input2.current.value = otp[1];
    //         input3.current.value = otp[2];
    //         input4.current.value = otp[3];

    //         setOtp(otp);
    //       }
    //       ac.abort();
    //     })
    //     .catch((err) => {
    //       // alert("Some error")
    //       ac.abort();
    //     });
    // }
  };

  const getOTP = () => {
    const inputs = [
      input1.current.value,
      input2.current.value,
      input3.current.value,
      input4.current.value,
    ];
    let temp = inputs[0] + inputs[1] + inputs[2] + inputs[3];
    setOtp(temp);
  };

  useEffect(() => {
    if (validateOtp()) {
      submitOTP();
    }
  }, [otp]);

  const validateOtp = () => {
    if (otp.length === 4 && /^\d+$/.test(otp)) {
      return true;
    }
    return false;
  };

  const requestOTP = async () => {
    // try {
    //   let payload = {
    //     data: {
    //       mobile_number: otpData.mobile,
    //     },
    //   };
    //   let { data } = await sentOtp(payload, "signin");
    //   if (data?.status) {
    //     setOtpData((st) => ({
    //       ...st,
    //       mobile: otpData.mobile,
    //       path: "home",
    //       method: "signup",
    //       vId: data?.data?.verificationId,
    //     }));
    //   }
    // } catch (error) {
    //   enqueueSnackbar(error.response.data.errors[0].message, {
    //     variant: "error",
    //   });
    // }
  };

  const submitOTP = async () => {
    setLoading(true);
    try {
      let payload = {
        otp,
        verificationId: vId,
      };

      let { data: response } = await verifyLogin(payload);
      setVerified(true);
      setTimeout(() => {
        setUser({
          ...response?.data,
          name: response?.data?.pan_details?.name || "User",
        });
        navigate(`/home`);
      }, 2000);
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.message || "Error", {
        variant: "error",
      });
      setOtp("");
      input1.current.value = "";
      input2.current.value = "";
      input3.current.value = "";
      input4.current.value = "";
    }
    setLoading(false);
  };

  const handleResend = () => {
    startTimer(5 * 60);
    setOver(false);
    setOtp("");
    input1.current.value = "";
    input2.current.value = "";
    input3.current.value = "";
    input4.current.value = "";
    requestOTP();
    enqueueSnackbar("OTP resent successfully", { variant: "success" });
  };

  function startTimer(duration, display) {
    var timer = duration,
      minutes,
      seconds;
    interval = setInterval(function () {
      minutes = parseInt(timer / 60, 10);
      seconds = parseInt(timer % 60, 10);

      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      setTimer(minutes + ":" + seconds);

      if (--timer === 0) {
        clearInterval(interval);
        setTimer("00:00");
        setOver(true);
      }
    }, 1000);
  }

  const handleInputSingle = (e, element) => {
    if (e.target.value !== "") return false;
    switch (e.key.toString().toLowerCase()) {
      case "backspace":
        return handleBackspace(e.target);
      case "arrowleft":
        return handleArrowLeft(e.target);
      case "arrowright":
        return handleArrowRight(e.target);
    }
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      // onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      PaperProps={{
        style: { borderRadius: 20 },
      }}
    >
      {isLoading && (
        <div className="strip w-100" style={{ position: "absolute", top: 0 }}>
          &nbsp;
        </div>
      )}
      <DialogContent>
        {!isVerified && (
          <div className="verification-wrapper mt-0">
            <Grid container spacing={2} className="pb-2">
              <Grid item xs={12} sm={12}>
                <Box className="form-box">
                  <p className="mb-5 otp-text">
                    An otp is sent to your <br></br>mobile number{" "}
                    <b>{otpData?.mobile}</b>
                  </p>
                  <form class="verification w-100" ref={verification}>
                    <input
                      ref={input1}
                      type="number"
                      autoComplete="off"
                      class="verification__input  verification__input--1"
                      id="verification-input-1"
                      placeholder="-"
                      maxLength="1"
                      inputMode="numeric"
                      onKeyDown={(e) => handleInputSingle(e, inputs[0])}
                      onInput={(e) => handleInput(e.target)}
                      onPaste={(e) => handlePaste(e)}
                      disabled={isLoading}
                    />
                    <input
                      ref={input2}
                      type="number"
                      autoComplete="off"
                      class="verification__input  verification__input--2"
                      id="verification-input-2"
                      placeholder="-"
                      maxLength="1"
                      inputMode="numeric"
                      onKeyDown={(e) => handleInputSingle(e, inputs[1])}
                      onInput={(e) => handleInput(e.target)}
                      onPaste={(e) => handlePaste(e)}
                      disabled={isLoading}
                    />
                    <input
                      ref={input3}
                      type="number"
                      autoComplete="off"
                      class="verification__input  verification__input--3"
                      id="verification-input-3"
                      placeholder="-"
                      maxLength="1"
                      inputMode="numeric"
                      onKeyDown={(e) => handleInputSingle(e, inputs[2])}
                      onInput={(e) => handleInput(e.target)}
                      onPaste={(e) => handlePaste(e)}
                      disabled={isLoading}
                    />
                    <input
                      ref={input4}
                      type="number"
                      class="verification__input  verification__input--4"
                      id="verification-input-4"
                      autoComplete="off"
                      placeholder="-"
                      maxLength="1"
                      inputMode="numeric"
                      onKeyDown={(e) => handleInputSingle(e, inputs[3])}
                      onInput={(e) => handleInput(e.target)}
                      onPaste={(e) => handlePaste(e)}
                      disabled={isLoading}
                    />
                  </form>
                  <div className="verification_footer">
                    <p className="info">
                      This session will end in {timer}.
                      <br />
                      {isOver && (
                        <>
                          Didn’t receive a code?{" "}
                          <span
                            className="pointer"
                            style={{ fontWeight: "500", color: "blue" }}
                            onClick={() => {
                              handleResend();
                            }}
                          >
                            Resend Code
                          </span>
                        </>
                      )}
                    </p>
                  </div>
                </Box>
              </Grid>
            </Grid>
          </div>
        )}

        {isVerified && (
          <div className="verification-div">
            <img src={successGif} width={"100%"} />
            <p className="text-center verified-text">Otp verified</p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default OtpLogin;
